import TpPlatformInvoiceSummaryItem from './TpPlatformInvoiceSummaryItem';

// "Additional" sub-tab of the Summarized Invoice Items tab: fee rows carry only an amount —
// no counts exist for additional fees.
export default class TpPlatformInvoiceSummaryAdditionalItem extends TpPlatformInvoiceSummaryItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Caspian Client',
        orderById: 'ClientName',
        data: 'ClientName',
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'TotalAmount',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
